import ExampleView from "../pages/pretests/ExampleView";
import Example from "../pages/pretests/Example";
import ExampleResult from "../pages/pretests/ExampleResult";
import MyAnswerSheets from "../pages/account/MyAnswerSheets";
import ExampleManage from "../pages/account/admin/pretests/ExampleManage";
import ExampleEditor from "../pages/account/admin/pretests/ExampleEditor";
import PublicCourseReviews from "../pages/reviews/PublicCourseReviews";
import MyCourseReviews from "../pages/account/MyCourseReviews";
import { Routes, Route } from "react-router-dom";
import RootLayout from "../shared/components/RootLayout";
import Error from "../shared/components/Error";
import HomeDefault from "../pages/home/HomeDefault";
import ArticlePage from "../pages/articles/ArticlePage";
import ArticleEditor from "../pages/account/creator/articles/ArticleEditor";

// Auth routes
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import VerifyEmail from "../pages/auth/VerifyEmail";

// Auth guards
import ProtectedRoute from "../shared/auth/ProtectedRoute"; // ล็อกอินพอ
import ProtectedRouteGuest from "../shared/auth/ProtectedRouteGuest"; // ยังไม่ล็อกอินเท่านั้น
import ProtectedRouteRole from "../shared/auth/ProtectedRouteRole"; // ตรวจ role creator/admin

import Profile from "../pages/account/Profile";
import AccountLayout from "../pages/account/AccountLayout";
import Overview from "../pages/account/Overview";
import Notifications from "../pages/account/Notifications";
import BookmarkArticle from "../pages/account/articles/BookmarkArticle";
import SearchResultPage from "../pages/search/SearchResultPage";
import UserInformation from "../pages/account/admin/UserInformation";
import TermsOfService from "../pages/info/TermsOfService";
import PrivacyPolicy from "../pages/info/PrivacyPolicy";
import AboutUs from "../pages/info/AboutUs";
import ContactUs from "../pages/info/ContactUs";
import EnChatInfo from "../pages/info/EnChatInfo";
import ContactMessages from "../pages/account/admin/ContactMessages";
import ImageGuidelinePage from "../pages/info/ImageGuidelinePage";

import CourseDetailPage from "../pages/courses/CourseDetailPage";
import CourseEnrollPage from "../pages/courses/CourseEnrollPage";

import VideoRowScrollMock from "../pages/courses/CourseVideoGalleryPage";
import UpdateCourseMock from "../pages/courses/UpdateCourseMock";

import MyCourseLists from "../pages/account/MyCourseLists";

// Creator
import VideoEditor from "../pages/account/creator/videos/VideoEditor";
import MyVideos from "../pages/account/creator/videos/MyVideos";
import MyCourses from "../pages/account/creator/courses/MyCourses";
import CreatorEnrollments from "../pages/account/creator/enrollments/CreatorEnrollments";
import CourseEditor from "../pages/account/creator/courses/CourseEditor";

// Admin
import AdminCourses from "../pages/account/admin/courses/AdminCourses";
import AdminVideos from "../pages/account/admin/videos/AdminVideos";
import AdminEnrollments from "../pages/account/admin/enrollments/AdminEnrollments";
import VideosPage from "../pages/videos/VideosPage";
import CoursesPage from "../pages/courses/CoursesPage";
import CourseView from "../pages/courses/CourseView";
import CoursePayment from "../pages/courses/CoursePayment";
import AccessControlSettingsPage from "../pages/account/admin/AccessControlSettingsPage";
import MyCoursePurchases from "../pages/account/MyCoursePurchases";
import CoursePaymentPromptpay from "../pages/courses/CoursePaymentPromptpay";
import HelpCenter from "../pages/info/HelpCenter";
import AdminCourseReviews from "../pages/account/admin/reviews/AdminCourseReviews";
import AdminImageModeration from "../pages/account/admin/moderation/AdminImageModeration";
import DeviceMonitorPage from "../pages/account/admin/DeviceMonitorPage";
import AffiliateApplyPage from "../pages/account/affiliate/AffiliateApplyPage";
import AffiliateProfilePage from "../pages/account/affiliate/AffiliateProfilePage";
import AffiliateLinksPage from "../pages/account/affiliate/AffiliateLinksPage";
import AffiliateEarningsPage from "../pages/account/affiliate/AffiliateEarningsPage";
import AdminAffiliateApplications from "../pages/account/admin/affiliates/AdminAffiliateApplications";
import AdminAffiliates from "../pages/account/admin/affiliates/AdminAffiliates";
import AdminAffiliateCommissions from "../pages/account/admin/affiliates/AdminAffiliateCommissions";

export default function AppRouter() {
  return (
    <Routes>
      <Route element={<RootLayout />}>
        {/* สาธารณะ */}
        <Route path="/" element={<HomeDefault />} />
        <Route path="/articles/:slug" element={<ArticlePage />} />
        <Route path="/search" element={<SearchResultPage />} />

        <Route path="/videos" element={<VideosPage />} />
        <Route path="/courses" element={<CoursesPage />} />
        <Route path="/pre-tests" element={<ExampleView />} />
        <Route path="/pre-tests/:testId" element={<Example />} />
        <Route path="/pre-tests/:testId/result" element={<ExampleResult />} />
        <Route path="/course-reviews" element={<PublicCourseReviews />} />

        {/* Info Pages */}
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/enchat" element={<EnChatInfo />} />
        <Route path="/help" element={<HelpCenter />} />

        {/* Course */}
        <Route path="/courses/:slug" element={<CourseDetailPage />} />

        <Route
          path="/account/creator/courses/:courseId/preview"
          element={
            <ProtectedRouteRole roles={["creator", "admin"]}>
              <CourseView />
            </ProtectedRouteRole>
          }
        />

        <Route
          path="/learn/:courseId"
          element={
            <ProtectedRoute>
              <CourseView />
            </ProtectedRoute>
          }
        />

        <Route
          path="/courses/:courseId/enroll"
          element={
            <ProtectedRoute>
              <CourseEnrollPage />
            </ProtectedRoute>
          }
        />

        <Route path="/courses/:courseId/payment/:enrollId" element={<CoursePayment />} />
        <Route path="/courses/:courseId/payment-promptpay/:enrollId" element={<CoursePaymentPromptpay />} />

        <Route path="/courses/videos/mock" element={<VideoRowScrollMock />} />
        <Route path="/courses/mock" element={<UpdateCourseMock />} />

        {/* Guest routes */}
        <Route
          path="/login"
          element={
            <ProtectedRouteGuest>
              <Login />
            </ProtectedRouteGuest>
          }
        />

        <Route
          path="/register"
          element={
            <ProtectedRouteGuest>
              <Register />
            </ProtectedRouteGuest>
          }
        />

        {/* ต้องล็อกอิน แต่ยังไม่ต้อง verified */}
        <Route
          path="/verify-email"
          element={
            <ProtectedRoute>
              <VerifyEmail />
            </ProtectedRoute>
          }
        />

        {/* Account zone */}
        <Route
          path="/account"
          element={
            <ProtectedRoute>
              <AccountLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Overview />} />
          <Route path="profile" element={<Profile />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="bookmarks" element={<BookmarkArticle />} />
          <Route path="my-courses" element={<MyCourseLists />} />
          <Route path="my-course-purchases" element={<MyCoursePurchases />} />
          <Route path="my-reviews" element={<MyCourseReviews />} />
          <Route path="my-answer-sheets" element={<MyAnswerSheets />} />
          <Route path="my-answer-sheets/:submissionId" element={<ExampleResult />} />
          <Route path="admin/pre-tests" element={<ProtectedRouteRole roles={["admin"]}><ExampleManage /></ProtectedRouteRole>} />
          <Route path="admin/pre-tests/new" element={<ProtectedRouteRole roles={["admin"]}><ExampleEditor /></ProtectedRouteRole>} />
          <Route path="admin/pre-tests/:testId/edit" element={<ProtectedRouteRole roles={["admin"]}><ExampleEditor /></ProtectedRouteRole>} />
          <Route path="affiliate/apply" element={<AffiliateApplyPage />} />
          <Route path="affiliate/profile" element={<AffiliateProfilePage />} />
          <Route path="affiliate/links" element={<AffiliateLinksPage />} />
          <Route path="affiliate/earnings" element={<AffiliateEarningsPage />} />

          {/* Creator: creator และ admin เข้าได้ */}
          <Route
            path="creator/videos"
            element={
              <ProtectedRouteRole roles={["creator", "admin"]}>
                <MyVideos />
              </ProtectedRouteRole>
            }
          />

          <Route
            path="creator/videos/new"
            element={
              <ProtectedRouteRole roles={["creator", "admin"]}>
                <VideoEditor />
              </ProtectedRouteRole>
            }
          />

          <Route
            path="creator/videos/:videoId"
            element={
              <ProtectedRouteRole roles={["creator", "admin"]}>
                <VideoEditor />
              </ProtectedRouteRole>
            }
          />

          <Route
            path="creator/courses"
            element={
              <ProtectedRouteRole roles={["creator", "admin"]}>
                <MyCourses />
              </ProtectedRouteRole>
            }
          />

          <Route
            path="creator/courses/new"
            element={
              <ProtectedRouteRole roles={["creator", "admin"]}>
                <CourseEditor />
              </ProtectedRouteRole>
            }
          />

          <Route
            path="creator/courses/:courseId"
            element={
              <ProtectedRouteRole roles={["creator", "admin"]}>
                <CourseEditor />
              </ProtectedRouteRole>
            }
          />

          <Route
            path="creator/enrollments"
            element={
              <ProtectedRouteRole roles={["creator", "admin"]}>
                <CreatorEnrollments />
              </ProtectedRouteRole>
            }
          />

          <Route
            path="creator/ImageGuidelinePage"
            element={
              <ProtectedRouteRole roles={["creator", "admin"]}>
                <ImageGuidelinePage />
              </ProtectedRouteRole>
            }
          />

          {/* Admin: admin เท่านั้น */}
          <Route
            path="admin/courses"
            element={
              <ProtectedRouteRole roles={["admin"]}>
                <AdminCourses />
              </ProtectedRouteRole>
            }
          />

          <Route
            path="admin/videos"
            element={
              <ProtectedRouteRole roles={["admin"]}>
                <AdminVideos />
              </ProtectedRouteRole>
            }
          />

          <Route
            path="admin/enrollments"
            element={
              <ProtectedRouteRole roles={["admin"]}>
                <AdminEnrollments />
              </ProtectedRouteRole>
            }
          />

          <Route
            path="admin/UserInformation"
            element={
              <ProtectedRouteRole roles={["admin"]}>
                <UserInformation />
              </ProtectedRouteRole>
            }
          />

          <Route
            path="admin/access-control"
            element={
              <ProtectedRouteRole roles={["admin"]}>
                <AccessControlSettingsPage />
              </ProtectedRouteRole>
            }
          />

          <Route
            path="admin/device-monitor"
            element={
              <ProtectedRouteRole roles={["admin"]}>
                <DeviceMonitorPage />
              </ProtectedRouteRole>
            }
          />

          <Route
            path="admin/ContactMessages"
            element={
              <ProtectedRouteRole roles={["admin"]}>
                <ContactMessages />
              </ProtectedRouteRole>
            }
          />

          <Route
            path="admin/image-moderation"
            element={
              <ProtectedRouteRole roles={["admin"]}>
                <AdminImageModeration />
              </ProtectedRouteRole>
            }
          />

          <Route
            path="admin/course-reviews"
            element={
              <ProtectedRouteRole roles={["admin"]}>
                <AdminCourseReviews />
              </ProtectedRouteRole>
            }
          />

          <Route
            path="admin/affiliate-applications"
            element={
              <ProtectedRouteRole roles={["creator", "admin"]}>
                <AdminAffiliateApplications />
              </ProtectedRouteRole>
            }
          />

          <Route
            path="admin/affiliates"
            element={
              <ProtectedRouteRole roles={["creator", "admin"]}>
                <AdminAffiliates />
              </ProtectedRouteRole>
            }
          />

          <Route
            path="admin/affiliate-commissions"
            element={
              <ProtectedRouteRole roles={["creator", "admin"]}>
                <AdminAffiliateCommissions />
              </ProtectedRouteRole>
            }
          />
        </Route>

        <Route
          path="/account/creator/ArticleEditor/:articleId"
          element={
            <ProtectedRouteRole roles={["creator", "admin"]}>
              <ArticleEditor />
            </ProtectedRouteRole>
          }
        />

        <Route
          path="/account/creator/ArticleEditor"
          element={
            <ProtectedRouteRole roles={["creator", "admin"]}>
              <ArticleEditor />
            </ProtectedRouteRole>
          }
        />

        {/* fallback */}
        <Route path="*" element={<Error />} />
      </Route>
    </Routes>
  );
}
